import { useContext } from 'react';
import { FieldValues, useForm } from 'react-hook-form';

import { AuthContext } from 'contexts';

const useNewPassword = () => {
  const authContext = useContext(AuthContext);
  const { handleSubmit, register } = useForm();

  const onSubmit = (data: FieldValues) => {
    const attributesData = {
      name: data.name,
      family_name: data.family_name,
    };

    authContext.completeNewPasswordChallenge(data.password, attributesData);
  };

  return {
    handleSubmit,
    register,
    onSubmit,
  };
};

export { useNewPassword };
